import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSAdocaoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  /**
   * Busca adoções anteriores do cliente para uma família comercial.
   * @param {string|number} clienteid
   * @param {string} famComercial - familia_comercial_id / referencia
   * @param {string|number|null} canalvendaid - opcional
   */
  async getAdocoesAnteriores(clienteid, famComercial, canalvendaid = null, temporada = null) {
    try {
      const params = { clienteid, famComercial };
      if (canalvendaid) params.canalvendaid = canalvendaid;
      if (temporada) params.temporada = temporada;
      return await this.api.get('pedido-venda/adocoes-anteriores', { params });
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar adoções anteriores');
    }
  }

  /**
   * Retorna o resumo do último pedido do cliente (sem necessidade de famComercial).
   * Usado pelo Carrinho Inteligente da tela de criação de pedido em Operações.
   * @param {string|number} clienteid
   * @param {string|number|null} canalvendaid - opcional
   */
  async getUltimoPedidoResumo(clienteid, canalvendaid = null) {
    try {
      const params = { clienteid };
      if (canalvendaid) params.canalvendaid = canalvendaid;
      return await this.api.get('pedido-venda/adocoes-anteriores/ultimo-pedido', { params });
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar resumo do último pedido');
    }
  }

  /**
   * Retorna os itens do pedido mais recente do cliente (opcionalmente do
   * representante), usado pelo modal "Auto completar pedido".
   * @param {string|number} clienteid
   * @param {string|number|null} representanteid - opcional
   * @param {number|null} limiteItens - opcional
   * @param {string|number|null} numeroPedido - filtro opcional por pedido exato
   * @param {string|null} dataPedido - filtro opcional por data do pedido (YYYY-MM-DD)
   */
  async getUltimosItensComprados(
    clienteid,
    representanteid = null,
    limiteItens = null,
    numeroPedido = null,
    dataPedido = null,
  ) {
    try {
      const params = { clienteid };
      if (representanteid) params.representanteid = representanteid;
      if (limiteItens) params.limiteItens = limiteItens;
      if (numeroPedido) params.numeroPedido = numeroPedido;
      if (dataPedido) params.dataPedido = dataPedido;
      return await this.api.get('pedido-venda/adocoes-anteriores/ultimos-itens', { params });
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar últimos itens comprados');
    }
  }
}
